module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Monday":"Montag","Tuesday":"Dienstag","Wednesday":"Mittwoch","Thursday":"Donnerstag","Friday":"Freitag","Saturday":"Samstag","Sunday":"Sonntag","Closed":"Geschlossen","Add hours":"Öffnungszeiten hinzufügen","Add":"Hinzufügen","Start":"Von","End":"Bis"}}')
  delete Component.options._Ctor
}
